// extracted by mini-css-extract-plugin
export default {"menuToggle":"MenuMovil_menuToggle__dLWKs","menu":"MenuMovil_menu__-5WEH"};